module.exports = __webpack_public_path__ + "img/Path.d3d4f38e.svg";